<div class="d-flex align-items-center py-4 bg-body-tertiary vh-100">
    <main class="form-signin w-100 m-auto">
        <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
            <img class="mb-3 bi-align-center logo" ngSrc="/assets/logo_color_login.png" alt="VineMeds" width="200" height="57" priority>
            <div class="h5 mb-3">Reset password</div>

            <div class="mb-3">
                <div>
                    @if (!checkPasswordForError('length')) {
                        <i class="bi bi-check-circle vm-icon-success"></i>
                    }
                    @if (checkPasswordForError('length')) {
                        <i class="bi bi-dash-circle vm-icon-danger"></i>
                    }
                    <span class="ps-2">Minimum length of 8 characters</span>
                </div>
                <div>
                    @if (!checkPasswordForError('lowercase')) {
                        <i class="bi bi-check-circle vm-icon-success"></i>
                    }
                    @if (checkPasswordForError('lowercase')) {
                        <i class="bi bi-dash-circle vm-icon-danger"></i>
                    }
                    <span class="ps-2">1 or more lowercase characters</span>
                </div>
                <div>
                    @if (!checkPasswordForError('uppercase')) {
                        <i class="bi bi-check-circle vm-icon-success"></i>
                    }
                    @if (checkPasswordForError('uppercase')) {
                        <i class="bi bi-dash-circle vm-icon-danger"></i>
                    }
                    <span class="ps-2">1 or more uppercase characters</span>
                </div>
                <div>
                    @if (!checkPasswordForError('number')) {
                        <i class="bi bi-check-circle vm-icon-success"></i>
                    }
                    @if (checkPasswordForError('number')) {
                        <i class="bi bi-dash-circle vm-icon-danger"></i>
                    }
                    <span class="ps-2">1 or more numbers</span>
                </div>
                <div>
                    @if (!checkPasswordForError('special')) {
                        <i class="bi bi-check-circle vm-icon-success"></i>
                    }
                    @if (checkPasswordForError('special')) {
                        <i class="bi bi-dash-circle vm-icon-danger"></i>
                    }
                    <span class="ps-2">1 or more special characters</span>
                </div>
            </div>

            <div class="input-group">
                <div class="form-floating">
                    <input [type]="passwordFieldType ? 'password' : 'text'" class="form-control shadow-none mb-0 password" id="passwordControl" formControlName="password">
                    <label for="passwordControl">Password</label>
                </div>

                <button type="button" class="btn btn-outline-primary" style="margin-bottom: -1px;" (click)="passwordFieldType = !passwordFieldType">
                    @if (passwordFieldType) {
                        <i class="bi bi-eye"></i>
                    }
                    @if (!passwordFieldType) {
                        <i class="bi bi-eye-slash"></i>
                    }
                </button>
            </div>

            <div class="input-group">
                <div class="form-floating">
                    <input [type]="confirmPasswordFieldType ? 'password' : 'text'" class="form-control shadow-none mb-0 confirmPassword" id="confirmPasswordControl" formControlName="confirmPassword">
                    <label for="confirmPasswordControl">Confirm Password</label>
                </div>

                <button type="button" class="btn btn-outline-primary" (click)="confirmPasswordFieldType = !confirmPasswordFieldType">
                    @if (confirmPasswordFieldType) {
                        <i class="bi bi-eye"></i>
                    }
                    @if (!confirmPasswordFieldType) {
                        <i class="bi bi-eye-slash"></i>
                    }
                </button>
            </div>
            @if (formGroup.hasError('notEqual')) {
                <div class="alert alert-danger">
                    <div>Password must match</div>
                </div>
            }

            <button [disabled]="loading" class="btn btn-primary w-100 py-2 mt-3">
                @if (loading) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                }
                Submit
            </button>
            <p class="mt-5 mb-3 text-body-secondary">&copy; 2022–2024</p>
        </form>
    </main>
</div>
